import { ASSETS } from "@/lib/site";

const STATS = [
  { value: "10+", label: "Years hosting guests" },
  { value: "12", label: "Rooms & suites" },
  { value: "8k+", label: "Happy guests" },
  { value: "3", label: "Acres of pine" },
];

export default function Why() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[color:var(--sh-charcoal)] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 items-center">
        {/* Left: image */}
        <div className="lg:col-span-5 sh-reveal">
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl">
            <img
              src={ASSETS.gallery2}
              alt="Sardar House cabins in the morning mist"
              className="w-full h-full object-cover sh-crop-mobile"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--sh-charcoal)]/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center gap-2 text-xs uppercase tracking-widest text-[color:var(--sh-cream)]">
              <span className="w-6 h-px bg-[color:var(--sh-amber)]" />
              A quieter kind of stay
            </div>
          </div>
        </div>

        {/* Right: copy + stats */}
        <div className="lg:col-span-7 sh-reveal">
          <div className="text-xs uppercase tracking-[0.35em] text-[color:var(--sh-amber)] mb-5">
            Why Sardar House
          </div>
          <h2
            data-testid="why-headline"
            className="sh-display text-[color:var(--sh-cream)] text-4xl sm:text-5xl lg:text-6xl font-medium max-w-2xl"
          >
            A cabin in the clouds, on the road less taken.
          </h2>
          <p className="mt-6 text-[color:var(--sh-cream-dim)] text-base sm:text-lg leading-relaxed max-w-2xl">
            Set on Kalabagh Road above the mist line of Nathia Gali, Sardar House
            is small, honest and quiet. Timber, stone, warm lamps and a bonfire that
            burns most evenings. Our rooms open toward the mountains — every window
            is a view.
          </p>

          <div
            data-testid="why-stats"
            className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4"
          >
            {STATS.map((s) => (
              <div
                key={s.label}
                className="sh-card rounded-2xl p-5"
                data-testid={`stat-${s.label.split(" ")[0].toLowerCase()}`}
              >
                <div className="sh-display text-[color:var(--sh-amber)] text-4xl sm:text-5xl">
                  {s.value}
                </div>
                <div className="mt-2 text-[11px] uppercase tracking-widest text-[color:var(--sh-cream-dim)]">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
